const cdsConfig = {
  colors: {
    'gray-050': 'hsl(240,11%,98%)',
    'gray-100': 'hsl(0,0%,96%)',
    'gray-200': 'hsl(0,0%,93%)',
    'gray-300': 'hsl(0,0%,88%)',
    'gray-400': 'hsl(0,0%,74%)',
    'gray-500': 'hsl(0,0%,62%)',
    'gray-600': 'hsl(0,0%,46%)',
    'gray-700': 'hsl(0,0%,38%)',
    'gray-800': 'hsl(0,0%,26%)',
    'gray-900': 'hsl(0,0%,13%)',
    'green-100': 'hsl(136,100%,97%)',
    'green-200': 'hsl(139,73%,87%)',
    'green-300': 'hsl(141,60%,75%)',
    'green-400': 'hsl(143,55%,62%)',
    'green-500': 'hsl(145,46%,51%)',
    'green-600': 'hsl(148,48%,43%)',
    'green-700': 'hsl(150,48%,35%)',
    'green-800': 'hsl(152,45%,28%)',
    'green-900': 'hsl(152,42%,23%)',
    'red-100': 'hsl(0,100%,98%)',
    'red-200': 'hsl(0,95%,92%)',
    'red-300': 'hsl(0,97%,85%)',
    'red-400': 'hsl(0,95%,75%)',
    'red-500': 'hsl(0,88%,68%)',
    'red-600': 'hsl(0,76%,57%)',
    'red-700': 'hsl(0,61%,48%)',
    'red-800': 'hsl(0,56%,39%)',
    'red-900': 'hsl(0,47%,31%)',
    'orange-100': 'hsl(40,100%,97%)',
    'orange-200': 'hsl(39,96%,89%)',
    'orange-300': 'hsl(38,93%,77%)',
    'orange-400': 'hsl(33,90%,65%)',
    'orange-500': 'hsl(27,84%,57%)',
    'orange-600': 'hsl(24,75%,50%)',
    'orange-700': 'hsl(20,71%,44%)',
    'orange-800': 'hsl(16,65%,37%)',
    'orange-900': 'hsl(14,61%,30%)',
    'yellow-100': 'hsl(60,100%,97%)',
    'yellow-200': 'hsl(58,97%,87%)',
    'yellow-300': 'hsl(55,92%,76%)',
    'yellow-400': 'hsl(51,89%,67%)',
    'yellow-500': 'hsl(47,81%,61%)',
    'yellow-600': 'hsl(40,67%,51%)',
    'yellow-700': 'hsl(36,71%,42%)',
    'yellow-800': 'hsl(32,75%,34%)',
    'yellow-900': 'hsl(30,76%,26%)',
    'teal-100': 'hsl(168,100%,95%)',
    'teal-200': 'hsl(170,77%,83%)',
    'teal-300': 'hsl(172,67%,70%)',
    'teal-400': 'hsl(174,59%,56%)',
    'teal-500': 'hsl(177,52%,46%)',
    'teal-600': 'hsl(179,51%,39%)',
    'teal-700': 'hsl(181,47%,33%)',
    'teal-800': 'hsl(181,47%,33%)',
    'teal-900': 'hsl(185,40%,23%)',
    'blue-100': 'hsl(201,100%,96%)',
    'blue-200': 'hsl(202,81%,86%)',
    'blue-300': 'hsl(203,82%,76%)',
    'blue-400': 'hsl(205,79%,66%)',
    'blue-500': 'hsl(207,73%,57%)',
    'blue-600': 'hsl(209,62%,50%)',
    'blue-700': 'hsl(211,61%,43%)',
    'blue-800': 'hsl(213,49%,34%)',
    'blue-900': 'hsl(215,41%,28%)',
    'indigo-100': 'hsl(213,100%,96%)',
    'indigo-200': 'hsl(217,97%,88%)',
    'indigo-300': 'hsl(221,90%,81%)',
    'indigo-400': 'hsl(225,86%,73%)',
    'indigo-500': 'hsl(229,76%,66%)',
    'indigo-600': 'hsl(234,62%,60%)',
    'indigo-700': 'hsl(237,47%,52%)',
    'indigo-800': 'hsl(242,38%,41%)',
    'indigo-900': 'hsl(247,33%,32%)',
    'purple-100': 'hsl(270,100%,98%)',
    'purple-200': 'hsl(268,90%,92%)',
    'purple-300': 'hsl(265,86%,86%)',
    'purple-400': 'hsl(262,81%,77%)',
    'purple-500': 'hsl(260,73%,70%)',
    'purple-600': 'hsl(259,59%,59%)',
    'purple-700': 'hsl(258,50%,52%)',
    'purple-800': 'hsl(256,44%,42%)',
    'purple-900': 'hsl(254,41%,34%)',
    'pink-100': 'hsl(348,100%,98%)',
    'pink-200': 'hsl(343,95%,92%)',
    'pink-300': 'hsl(339,90%,85%)',
    'pink-400': 'hsl(336,86%,75%)',
    'pink-500': 'hsl(331,79%,66%)',
    'pink-600': 'hsl(329,64%,54%)',
    'pink-700': 'hsl(325,57%,46%)',
    'pink-800': 'hsl(322,60%,37%)',
    'pink-900': 'hsl(318,51%,29%)',
    'ct-green-050': 'rgb(239, 255, 251)',
    'ct-green-100': 'rgb(199, 240, 221)',
    'ct-green-300': 'rgb(98, 241, 189)',
    'ct-green-500': 'rgb(0, 200, 150)',
    'ct-green-700': 'rgb(23, 162, 126)',
    'ct-green-900': 'rgb(12, 141, 109)',

    /* molecules/Nav */
    'border-nav-active': 'rgb(0, 200, 150)',
    'text-nav-active': 'rgb(0, 200, 150)',
    'text-nav-normal': 'hsl(0,0%,62%)',

    white: 'hsl(0,0%,100%)',
    black: 'hsl(0,0%,0%)',
    transparent: 'hsla(0, 0%, 0%, 0)',

    'text-dark': 'hsl(0,0%,13%)',
    'text-sub-dark': 'hsl(0,0%,26%)',
    'text-medium': 'hsl(0,0%,46%)',
    'text-light': 'hsl(0,0%,62%)',
    'text-disabled': 'hsl(0,0%,74%)',
  },
  space: {
    '$00': '0',
    '$01': '0.25rem', // 4px
    '$02': '0.5rem', // 8px
    '$03': '0.75rem', // 12px
    '$04': '1rem', // 16px
    '$05': '1.25rem', // 20px
    '$06': '1.5rem', // 24px
    '$07': '2rem', // 32px

    'layout-01': '1.5rem',
    'layout-02': '2.25rem',
    'layout-03': '3rem',
    'layout-04': '3.5rem',
    'layout-05': '4rem',
    'layout-06': '4.5rem',
    'layout-07': '5.5rem',
    'layout-08': '6rem',
    'layout-09': '7.5rem',
  },
  sizes: {
    'width-xs': '320px',
    'width-sm': '540px',
    'width-md': '720px',
    'width-lg': '960px',
    'width-xl': '1140px',
    'width-xxl': '1280px',
  },
  shadows: {
    // MS Edge에서 shadow hsla 동작하지 않음
    sm: '0px 2px 4px rgba(0,0,0,0.08)',
    md: '0px 2px 4px rgba(0,0,0,0.16)',
    lg: '0px 2px 8px rgba(0,0,0,0.24)',
    xl: '0px 2px 8px rgba(0,0,0,0.36)',
    'sm-centered': '0px 2px 12px rgba(0,0,0,0.08)',
  },
  fontWeights: {
    regular: '400',
    medium: '500',
    bold: '700',

    'heading': '700',
    'heading-mobile': '700',
  },
  fontSizes: {
    'size-60': '0.75rem',
    'size-70': '0.8125rem',
    'size-80': '0.875rem',
    'size-90': '0.938rem',
    'size-100': '1rem', // base
    'size-120': '1.125rem',
    'size-140': '1.25rem',
    'size-150': '1.5rem',
    'size-160': '1.625rem',
    'size-180': '2rem',
    'size-200': '2.75rem',
    'size-220': '3.25rem',

    '50': '0.75rem',
    '75': '0.875rem',
    '100': '1rem', // base
    '200': '1.125rem',
    '300': '1.25rem',
    '400': '1.375rem',
    '500': '1.5rem',
    '600': '1.75rem',
    '700': '2.25rem',
    '800': '2.625rem',
    '900': '3.5rem',

    'heading': '1.125rem',
    'heading-mobile': '1.375rem',
  },
  lineHeights: {
    base: '150%',
    lg: '130%', // large-text?

    '01': '1',
    '02': '1.214',
    '03': '1.222',
    '04': '1.285',
    '05': '1.333',
    '06': '1.363',
    '07': '1.4',
    '08': '1.416',
    '09': '1.424',
    '10': '1.428',
    '11': '1.454',
    '12': '1.5',
    '13': '1.555',

    heading: '1.363',
    'heading-mobile': '1.363',
  },
  radii: {
    xs: '0.25rem',
    sm: '0.375rem',
    md: '0.5rem',
    lg: '1rem',
    xl: '1.5rem',
    pill: '999rem',
    circle: '100%',
  },
  media: {
    xs: '@media (min-width: 320px)',
    sm: '@media (min-width: 540px)',
    md: '@media (min-width: 720px)',
    lg: '@media (min-width: 960px)',
    xl: '@media (min-width: 1140px)',
    xxl: '@media (min-width: 1280px)',
  },
}

export default cdsConfig;
